import { hasConstructionDiaryAccessRole } from '@core/shared-bridge';

/**
 * Web: kdo vidí Stavební deník (položka menu /diary, globální modal, potvrzení zápisu).
 * Stavba + admin + superadmin. Backend má vlastní kontrolu — tato funkce je jen pro UI.
 */
export function webCanAccessConstructionDiary(roles: string[] | undefined | null): boolean {
  return hasConstructionDiaryAccessRole(roles);
}
